import { color, Common } from '@stockbit/ui';
import { Form as AntdForm, Row, Select } from 'antd';
import styled from 'styled-components';

const { Button, Modal, Text } = Common;

// eslint-disable-next-line import/prefer-default-export
export const ErrorBox = styled.div`
  display: flex;
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #f7aead;
  background-color: #fef6f6;
  align-items: center;
  margin-top: 32px;
  color: #333333;

  .icon {
    position: relative;
    display: inline-block;
    color: #ee4a49;
    background: #fff;
    border: 1px solid #ee4a49;
    border-radius: 50%;
    width: 14px;
    height: 14px;
    margin-right: 5px;
    margin-bottom: 2px;

    &::before {
      position: absolute;
      content: 'i';
      left: 42%;
      font-size: 10px;
    }
  }
`;

export const SpecialMonitoringModalContainer = styled(Modal)`
  .ant-modal-close {
    margin-top: 24px;
    margin-right: 14px;
  }

  .special-monitoring__content {
    height: 560px;
    overflow-y: scroll;
    position: relative;
    padding: 0 30px 30px;

    &::-webkit-scrollbar {
      width: 0;
    }

    & .special-monitoring__card {
      border: 1px solid ${color.downgray};
      border-radius: 4px;
      margin-top: 20px;

      &:first-child {
        margin-top: 0;
      }

      & .special-monitoring__header {
        padding: 16px 20px;
        border-bottom: 1px solid ${color.downgray};
      }

      & .special-monitoring__body {
        padding: 16px 20px;

        & ul {
          padding-inline-start: 24px;

          & li {
            margin-bottom: 20px;

            &::marker {
              color: ${color.highempahis};
            }

            &:last-child {
              margin-bottom: 0;
            }
          }
        }

        & .special-monitoring__session-container {
          margin-top: 20px;

          & p {
            margin-bottom: 8px;
          }

          & .special-monitoring__session-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
        }
      }
    }
  }
`;

export const SpecialMonitoringButton = styled(Button)`
  position: absolute;
  bottom: -55px;
  width: 100%;

  :disabled {
    background: #616161;
    border-color: #616161;
    color: #bcbcbc;
  }
`;

export const SliderPercentText = styled(Text)`
  padding-left: 5px;
  width: 40px;
  white-space: nowrap;
`;

export const FormExerciseFieldWrapper = styled.div`
  & > div {
    padding: 16px 0;

    &:last-child {
      padding-bottom: 0;
    }
  }
`;

export const BalanceButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;

  background: none;
  border: none;
  cursor: pointer;

  padding: 0;

  & > span {
    margin-left: 6px;
  }

  &:disabled {
    cursor: unset;
  }

  .multiplier-chip {
    font-size: 14px;
    line-height: 19px;
    border-color: #f2f1fe;
    background-color: #f2f1fe;
    color: #8277f8;
    padding: 2px 8px;
    margin-left: 4px;
    display: flex;
    gap: 2px;
  }
`;

export const TransactionForm = styled(AntdForm)`
  margin-right: 40px;

  & div.ant-form-item-explain {
    width: calc(100% + 40px);
  }

  & div.ant-form-item-control {
    max-width: 160px;
  }

  & .slider-form-item div.ant-form-item-control {
    max-width: unset;
  }
`;

export const FieldsWrapper = styled.div`
  & > div.ant-form-item {
    margin-bottom: 20px;

    :last-child {
      margin-bottom: 0;
    }
  }
`;

export const SelectForm = styled(Select)`
  font-weight: bold;
  width: 100%;
`;

export const HeaderWrapper = styled(Row)`
  align-items: center;
  justify-content: space-between;

  padding-right: 36px;
  margin-bottom: 8px;
`;
